export default __webpack_public_path__ + "4ee27cf5974bbad74e9f90a8e06a0acb.svg";